import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Auth
    login: 'Connexion',
    register: 'Inscription',
    email: 'Email',
    password: 'Mot de passe',
    companyName: 'Nom de l\'entreprise',
    loginTitle: 'Connectez-vous à HICALL',
    registerTitle: 'Créez votre compte',
    noAccount: 'Pas encore de compte ?',
    hasAccount: 'Déjà un compte ?',
    signUp: 'S\'inscrire',
    signIn: 'Se connecter',
    
    // Navigation
    dashboard: 'Tableau de bord',
    settings: 'Paramètres',
    integration: 'Intégration',
    logout: 'Déconnexion',
    
    // Dashboard
    callbackRequests: 'Demandes de rappel',
    totalRequests: 'Total des demandes',
    pending: 'En attente',
    completed: 'Complétées',
    last7Days: '7 derniers jours',
    noCallbacks: 'Aucune demande de rappel pour le moment',
    noCallbacksDesc: 'Les demandes apparaîtront ici dès que vos visiteurs utiliseront le widget.',
    exportCsv: 'Exporter CSV',
    phone: 'Téléphone',
    page: 'Page',
    status: 'Statut',
    date: 'Date',
    actions: 'Actions',
    markCompleted: 'Marquer comme traité',
    delete: 'Supprimer',
    
    // Settings
    popupSettings: 'Paramètres du popup',
    enabled: 'Activé',
    disabled: 'Désactivé',
    popupTitle: 'Titre du popup',
    popupMessage: 'Message du popup',
    ctaButton: 'Texte du bouton',
    legalText: 'Texte légal (RGPD)',
    primaryColor: 'Couleur principale',
    
    notifications: 'Notifications',
    webhookUrl: 'URL du Webhook',
    webhookEnabled: 'Webhook activé',
    emailEnabled: 'Email activé',
    notificationEmail: 'Email de notification',
    testWebhook: 'Tester le webhook',
    
    gdprSettings: 'Paramètres RGPD',
    dataRetention: 'Durée de conservation (jours)',
    
    behaviorSettings: 'Comportement',
    triggerOnce: 'Déclencher une seule fois par session',
    inactivityTimeout: 'Délai d\'inactivité (secondes)',
    callbackHours: 'Heures de rappel',
    from: 'De',
    to: 'À',
    
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    saved: 'Enregistré',
    
    // Integration
    integrationTitle: 'Intégrez HICALL sur votre site',
    integrationDesc: 'Copiez ce code et collez-le juste avant la balise </body> de votre site.',
    copyCode: 'Copier le code',
    copied: 'Copié !',
    
    // Widget
    beforeYouGo: 'Avant de partir...',
    wantCallback: 'Souhaitez-vous être rappelé gratuitement par notre équipe ?',
    yourPhone: 'Votre numéro de téléphone',
    requestCallback: 'Être rappelé',
    consentText: 'J\'accepte d\'être recontacté par téléphone',
    thankYou: 'Merci !',
    callbackConfirm: 'Nous vous rappellerons très bientôt.',
    close: 'Fermer',
    invalidPhone: 'Numéro de téléphone invalide',
    consentRequired: 'Vous devez accepter d\'être recontacté',
    
    // Demo
    demoTitle: 'Testez le widget',
    demoDesc: 'Déplacez votre souris vers le haut de la page pour déclencher le popup.',
    
    // Errors
    loginError: 'Email ou mot de passe incorrect',
    registerError: 'Erreur lors de l\'inscription',
    networkError: 'Erreur de connexion au serveur',
  },
  en: {
    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    companyName: 'Company name',
    loginTitle: 'Sign in to HICALL',
    registerTitle: 'Create your account',
    noAccount: 'Don\'t have an account?',
    hasAccount: 'Already have an account?',
    signUp: 'Sign up',
    signIn: 'Sign in',
    
    // Navigation
    dashboard: 'Dashboard',
    settings: 'Settings',
    integration: 'Integration',
    logout: 'Logout',
    
    // Dashboard
    callbackRequests: 'Callback Requests',
    totalRequests: 'Total Requests',
    pending: 'Pending',
    completed: 'Completed',
    last7Days: 'Last 7 Days',
    noCallbacks: 'No callback requests yet',
    noCallbacksDesc: 'Requests will appear here when visitors use the widget.',
    exportCsv: 'Export CSV',
    phone: 'Phone',
    page: 'Page',
    status: 'Status',
    date: 'Date',
    actions: 'Actions',
    markCompleted: 'Mark as completed',
    delete: 'Delete',
    
    // Settings
    popupSettings: 'Popup Settings',
    enabled: 'Enabled',
    disabled: 'Disabled',
    popupTitle: 'Popup title',
    popupMessage: 'Popup message',
    ctaButton: 'Button text',
    legalText: 'Legal text (GDPR)',
    primaryColor: 'Primary color',
    
    notifications: 'Notifications',
    webhookUrl: 'Webhook URL',
    webhookEnabled: 'Webhook enabled',
    emailEnabled: 'Email enabled',
    notificationEmail: 'Notification email',
    testWebhook: 'Test webhook',
    
    gdprSettings: 'GDPR Settings',
    dataRetention: 'Data retention (days)',
    
    behaviorSettings: 'Behavior',
    triggerOnce: 'Trigger once per session',
    inactivityTimeout: 'Inactivity timeout (seconds)',
    callbackHours: 'Callback hours',
    from: 'From',
    to: 'To',
    
    save: 'Save',
    saving: 'Saving...',
    saved: 'Saved',
    
    // Integration
    integrationTitle: 'Integrate HICALL on your website',
    integrationDesc: 'Copy this code and paste it just before the </body> tag of your website.',
    copyCode: 'Copy code',
    copied: 'Copied!',
    
    // Widget
    beforeYouGo: 'Before you go...',
    wantCallback: 'Would you like a free callback from our team?',
    yourPhone: 'Your phone number',
    requestCallback: 'Request callback',
    consentText: 'I agree to be contacted by phone',
    thankYou: 'Thank you!',
    callbackConfirm: 'We will call you back very soon.',
    close: 'Close',
    invalidPhone: 'Invalid phone number',
    consentRequired: 'You must agree to be contacted',
    
    // Demo
    demoTitle: 'Test the widget',
    demoDesc: 'Move your mouse to the top of the page to trigger the popup.',
    
    // Errors
    loginError: 'Invalid email or password',
    registerError: 'Registration error',
    networkError: 'Server connection error',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('exitflow-language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('exitflow-language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
